<div class="image-upload input-group">
  @if (imageUrl) {
    <img
      src="{{ imageUrl }}"
      class="avatar avatar--medium"
      />
  } @else {
    <div class="avatar avatar--medium avatar--placeholder text-gray-light">
      <i class="fas fa-user avatar__placeholder-icon" aria-hidden="true"></i>
    </div>
  }


  <label class="image-upload__button form-label btn btn-outline-secondary">
    <input
      type="file"
      class="d-none"
      id="customFile"
      id="fileupload"
      #fileInput
      ng2FileSelect
      [uploader]="uploader"
      (change)="fileInput.value = ''"
      accept="image/*"
      />
    @if (isRefreshingPicture) {
      <i
        class="ms-1 text-muted fas fa-circle-notch fa-spin"
      ></i>
    }
    @if (!isRefreshingPicture) {
      <span i18n>Choose image</span>
    }
  </label>
</div>
